import { FormattedMessage } from "react-intl";
import Alert from "reactstrap/lib/Alert";
import Col from "reactstrap/lib/Col";
import Row from "reactstrap/lib/Row";
import { formatDate } from "../../Utilities/dateUtils";
import {
  DayBars,
  PanelCard,
  StatCard,
  formatCompact,
  formatNumber,
} from "./DailyAnalysisParts";

function DailyAnalysisApl({ data }) {
  const apl = data.apl;

  if (!apl) {
    return (
      <Alert color="light" className="da-banner">
        <FormattedMessage id="NothingToShow" />
      </Alert>
    );
  }

  const day = apl.byDay.find((row) => row.date === data.date);
  const requests = day.succeededRequests + day.failedRequests;
  const perDay = (field) =>
    apl.byDay.map((row) => ({
      label: formatDate(row.date, "d/M"),
      count: row[field],
    }));
  const attendanceHours = apl.attendanceByHour.map((count, hour) => ({
    label: String(hour).padStart(2, "0"),
    count,
  }));
  const attendancePeakHour = attendanceHours.reduce(
    (a, b) => (b.count > a.count ? b : a),
    attendanceHours[0],
  );

  return (
    <div>
      <Row className="da-equal">
        <Col md="3" sm="6">
          <StatCard
            labelId="DailyAnalysisAplRequests"
            value={formatCompact(requests)}
            note={
              requests ? (
                <FormattedMessage
                  id="DailyAnalysisAplFailedShare"
                  values={{
                    value: (
                      (day.failedRequests / requests) *
                      100
                    ).toLocaleString("sv-SE", { maximumFractionDigits: 1 }),
                  }}
                />
              ) : (
                ""
              )
            }
          />
        </Col>
        <Col md="3" sm="6">
          <StatCard
            labelId="DailyAnalysisAplAttendance"
            value={formatNumber(day.attendance)}
          />
        </Col>
        <Col md="3" sm="6">
          <StatCard
            labelId="DailyAnalysisAplWorkCard"
            value={formatNumber(day.workCard)}
          />
        </Col>
        <Col md="3" sm="6">
          <StatCard
            labelId="DailyAnalysisAplSignatures"
            value={formatNumber(day.signatures)}
            note={<FormattedMessage id="DailyAnalysisAplSignaturesNote" />}
          />
        </Col>
      </Row>

      <Row className="da-equal">
        <Col md="6">
          <PanelCard titleId="DailyAnalysisAplSucceededPerDay">
            <DayBars points={perDay("succeededRequests")} />
          </PanelCard>
        </Col>
        <Col md="6">
          <PanelCard titleId="DailyAnalysisAplFailedPerDay">
            <DayBars points={perDay("failedRequests")} />
          </PanelCard>
        </Col>
      </Row>

      <Row className="da-equal">
        <Col md="6">
          <PanelCard titleId="DailyAnalysisAplAttendancePerDay">
            <DayBars points={perDay("attendance")} />
          </PanelCard>
        </Col>
        <Col md="6">
          <PanelCard
            titleId="DailyAnalysisAplAttendancePerHour"
            subtitle={
              attendancePeakHour.count > 0 ? (
                <FormattedMessage
                  id="DailyAnalysisAplAttendancePeakHour"
                  values={{
                    hour: attendancePeakHour.label,
                    count: formatNumber(attendancePeakHour.count),
                  }}
                />
              ) : (
                ""
              )
            }
          >
            <DayBars points={attendanceHours} labelEvery={6} />
          </PanelCard>
        </Col>
      </Row>

      <Row className="da-equal">
        <Col md="6">
          <PanelCard titleId="DailyAnalysisAplWorkCardPerDay">
            <DayBars points={perDay("workCard")} />
          </PanelCard>
        </Col>
        <Col md="6">
          <PanelCard titleId="DailyAnalysisAplSignaturesPerDay">
            <DayBars points={perDay("signatures")} />
          </PanelCard>
        </Col>
      </Row>
    </div>
  );
}

export default DailyAnalysisApl;
